<!--教师年龄-->
<template>
    <div class="my-charts">
        <div :id="id" style="margin-top: -25px;"></div>
    </div>
</template>


<script>
import * as echarts from "echarts";

export default {
    name: "jl4Echarts",
    props: {
        id:{
            type: String,
            default:"jl2_echarts"
        },
        teaCount:{
            type: Number,
            default: 0
        },
        teaTimeCount:{
            type: Number,
            default: 0
        },
        teaTimeRate:{
            type: Number,
            default: 0
        },
    },
    watch:{
        id(newValue,oldValue){
            this.id = newValue;
        },
    },
    data() {
        return {
            pieChart: null, // 饼图
            chartOption:{
                title: {
                    show:false,
                },
                legend: {
                    show: true,
                    bottom:-3,
                    textStyle: {
                        color: '#fff',
                    },
                    itemStyle: {
                        borderWidth: 1,
                        borderColor: '#fff',
                    },
                },
                graphic: [
                    {
                        type: "text",
                        left: "center",
                        top: "center",
                        style: {
                            text: '',
                            textAlign: "center",
                            lineHeight:30,
                            fontSize: 16,
                            fill: "#ffffff",
                        },
                    },
                ],
                series: [
                    {
                        name: '教龄分析：',
                        type: 'pie',
                        radius: ['45%', '70%'],
                        color: [
                            '#acd78e',
                            '#205ae0',
                        ],
                        label: {
                            show: false,
                            position: 'right'
                        },
                        labelLine: {
                            show: true
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        },
                        itemStyle: {
                            borderWidth: 1,
                            borderColor: '#fff',
                        },
                        data: []
                    }
                ]
            }
        };
    },
    computed: {},
    mounted() {
        this.init();
    },
    updated() {
        this.init();
    },
    methods: {
        init() {
            const list = []
            list.push({'value':this.teaTimeCount,'name':"20年以上"});
            list.push({'value':this.teaCount-this.teaTimeCount,'name':this.teaTimeCount+"人 "+this.teaTimeRate+"%"});
            this.pieChart = echarts.init(document.getElementById(this.id));
            this.chartOption.series[0].data = []
            this.chartOption.series[0].data = list;
            this.chartOption.graphic[0].style.text = this.teaTimeRate+"%"
            this.pieChart.setOption(this.chartOption);
        }
    }
};
</script>

<style scoped lang="scss">
.my-charts {
    flex-direction: column;
    div {
        width: 100%!important;
        height: calc(50vh - 160px);
    }
}
</style>